// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.data-delete-container {
  background-color: #f5f5f5;
  min-height: 100vh;
  padding: 3rem 1.5rem;
}

.data-delete-content {
  max-width: 1024px;
  margin: 0 auto;
  background-color: white;
  padding: 2rem;
  border-radius: 8px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
}

.badge {
  background-color: #e6f0fd;
  color: #2563eb;
  font-size: 0.875rem;
  font-weight: 500;
  padding: 0.25rem 0.75rem;
  border-radius: 4px;
  display: inline-block;
  margin-bottom: 1rem;
}

.header-section {
  border-bottom: 1px solid #f1f1f1;
  padding-bottom: 1.5rem;
  margin-bottom: 2rem;
}

.title {
  font-size: 2rem;
  font-weight: 700;
  margin-bottom: 1.5rem;
  color: #1f2937;
}

.subtitle {
  font-size: 1.5rem;
  font-weight: 700;
  margin-bottom: 1rem;
  color: #1f2937;
  display: flex;
  align-items: center;
}

.subtitle svg {
  margin-right: 0.75rem;
  color: #2563eb;
}

.text {
  color: #4b5563;
  margin-bottom: 1rem;
}

.last-updated {
  display: flex;
  justify-content: flex-end;
  align-items: center;
  color: #6b7280;
  font-size: 0.875rem;
}

.last-updated svg {
  margin-right: 0.5rem;
  color: #9ca3af;
}

.info-box {
  background-color: #e6f0fd;
  border-left: 4px solid #60a5fa;
  padding: 1rem;
  border-radius: 0 4px 4px 0;
  margin-bottom: 2rem;
}

.section {
  margin-bottom: 2.5rem;
}

.steps-list {
  list-style: none;
  padding-left: 2rem;
}

.step-item {
  display: flex;
  align-items: flex-start;
  margin-bottom: 0.75rem;
}

.step-number {
  background-color: #e6f0fd;
  color: #2563eb;
  width: 1.5rem;
  height: 1.5rem;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-right: 0.75rem;
  flex-shrink: 0;
  font-size: 0.875rem;
}

.email-box {
  background-color: #f9fafb;
  padding: 1rem;
  border-radius: 8px;
  border: 1px solid #f1f1f1;
  display: inline-block;
}

.email-link {
  display: flex;
  align-items: center;
  color: #4b5563;
}

.email-link svg {
  margin-right: 0.5rem;
  color: #2563eb;
}

.email-link a {
  color: #2563eb;
  margin-left: 0.5rem;
  font-weight: 500;
  text-decoration: none;
}

.email-link a:hover {
  text-decoration: underline;
}

.contact-section {
  margin-top: 3rem;
  padding-top: 1.5rem;
  border-top: 1px solid #e5e7eb;
}

.contact-link {
  color: #2563eb;
  font-weight: 500;
  text-decoration: none;
}

.contact-link:hover {
  text-decoration: underline;
} `, "",{"version":3,"sources":["webpack://./src/pages/Agreements/DataDelete.css"],"names":[],"mappings":"AAAA;EACE,yBAAyB;EACzB,iBAAiB;EACjB,oBAAoB;AACtB;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,uBAAuB;EACvB,aAAa;EACb,kBAAkB;EAClB,wCAAwC;AAC1C;;AAEA;EACE,yBAAyB;EACzB,cAAc;EACd,mBAAmB;EACnB,gBAAgB;EAChB,wBAAwB;EACxB,kBAAkB;EAClB,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA;EACE,gCAAgC;EAChC,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,mBAAmB;EACnB,cAAc;EACd,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,mBAAmB;EACnB,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;EACpB,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,8BAA8B;EAC9B,aAAa;EACb,0BAA0B;EAC1B,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,sBAAsB;AACxB;;AAEA;EACE,yBAAyB;EACzB,cAAc;EACd,aAAa;EACb,cAAc;EACd,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,qBAAqB;EACrB,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;EACzB,aAAa;EACb,kBAAkB;EAClB,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,oBAAoB;EACpB,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,mBAAmB;EACnB,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,6BAA6B;AAC/B;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;EACE,0BAA0B;AAC5B","sourcesContent":[".data-delete-container {\n  background-color: #f5f5f5;\n  min-height: 100vh;\n  padding: 3rem 1.5rem;\n}\n\n.data-delete-content {\n  max-width: 1024px;\n  margin: 0 auto;\n  background-color: white;\n  padding: 2rem;\n  border-radius: 8px;\n  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);\n}\n\n.badge {\n  background-color: #e6f0fd;\n  color: #2563eb;\n  font-size: 0.875rem;\n  font-weight: 500;\n  padding: 0.25rem 0.75rem;\n  border-radius: 4px;\n  display: inline-block;\n  margin-bottom: 1rem;\n}\n\n.header-section {\n  border-bottom: 1px solid #f1f1f1;\n  padding-bottom: 1.5rem;\n  margin-bottom: 2rem;\n}\n\n.title {\n  font-size: 2rem;\n  font-weight: 700;\n  margin-bottom: 1.5rem;\n  color: #1f2937;\n}\n\n.subtitle {\n  font-size: 1.5rem;\n  font-weight: 700;\n  margin-bottom: 1rem;\n  color: #1f2937;\n  display: flex;\n  align-items: center;\n}\n\n.subtitle svg {\n  margin-right: 0.75rem;\n  color: #2563eb;\n}\n\n.text {\n  color: #4b5563;\n  margin-bottom: 1rem;\n}\n\n.last-updated {\n  display: flex;\n  justify-content: flex-end;\n  align-items: center;\n  color: #6b7280;\n  font-size: 0.875rem;\n}\n\n.last-updated svg {\n  margin-right: 0.5rem;\n  color: #9ca3af;\n}\n\n.info-box {\n  background-color: #e6f0fd;\n  border-left: 4px solid #60a5fa;\n  padding: 1rem;\n  border-radius: 0 4px 4px 0;\n  margin-bottom: 2rem;\n}\n\n.section {\n  margin-bottom: 2.5rem;\n}\n\n.steps-list {\n  list-style: none;\n  padding-left: 2rem;\n}\n\n.step-item {\n  display: flex;\n  align-items: flex-start;\n  margin-bottom: 0.75rem;\n}\n\n.step-number {\n  background-color: #e6f0fd;\n  color: #2563eb;\n  width: 1.5rem;\n  height: 1.5rem;\n  border-radius: 50%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  margin-right: 0.75rem;\n  flex-shrink: 0;\n  font-size: 0.875rem;\n}\n\n.email-box {\n  background-color: #f9fafb;\n  padding: 1rem;\n  border-radius: 8px;\n  border: 1px solid #f1f1f1;\n  display: inline-block;\n}\n\n.email-link {\n  display: flex;\n  align-items: center;\n  color: #4b5563;\n}\n\n.email-link svg {\n  margin-right: 0.5rem;\n  color: #2563eb;\n}\n\n.email-link a {\n  color: #2563eb;\n  margin-left: 0.5rem;\n  font-weight: 500;\n  text-decoration: none;\n}\n\n.email-link a:hover {\n  text-decoration: underline;\n}\n\n.contact-section {\n  margin-top: 3rem;\n  padding-top: 1.5rem;\n  border-top: 1px solid #e5e7eb;\n}\n\n.contact-link {\n  color: #2563eb;\n  font-weight: 500;\n  text-decoration: none;\n}\n\n.contact-link:hover {\n  text-decoration: underline;\n} "],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
